import { render, staticRenderFns } from "./TaskApprove.vue?vue&type=template&id=0951dbf8&"
import script from "./TaskApprove.vue?vue&type=script&lang=js&"
export * from "./TaskApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports